
import React from 'react';
import { MetricFormatter, getTimingColor } from './MetricFormatter';
import PerformanceScore from './PerformanceScore';

interface OverviewTabProps {
  metrics: any;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ metrics }) => {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-2">
      <div className="flex flex-col">
        <span className="text-gray-500 dark:text-gray-400">Time to Interactive:</span>
        <span className={getTimingColor(metrics.timeToInteractive)}>
          <MetricFormatter value={metrics.timeToInteractive} type="time" />
        </span>
      </div>
      
      <div className="flex flex-col">
        <span className="text-gray-500 dark:text-gray-400">First Paint:</span>
        <span className={getTimingColor(metrics.firstContentfulPaint)}>
          <MetricFormatter value={metrics.firstContentfulPaint} type="time" />
        </span>
      </div>

      <div className="flex flex-col">
        <span className="text-gray-500 dark:text-gray-400">DOM Content Loaded:</span>
        <span className={getTimingColor(metrics.domContentLoaded)}>
          <MetricFormatter value={metrics.domContentLoaded} type="time" />
        </span>
      </div>
      
      <div className="flex flex-col">
        <span className="text-gray-500 dark:text-gray-400">Load Complete:</span>
        <span className={getTimingColor(metrics.loadComplete)}>
          <MetricFormatter value={metrics.loadComplete} type="time" />
        </span>
      </div>

      {/* Performance score indicator */}
      <div className="col-span-2 mt-2">
        <div className="flex justify-between items-center">
          <span className="text-gray-500 dark:text-gray-400">Performance score:</span>
          <PerformanceScore metrics={metrics} />
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
